'use strict';

var getColorMix = {};

exports.__exports = getColorMix;
//# sourceMappingURL=getColorMix.cjs.map
